import { render } from "./OffCanvasBody.vue?vue&type=template&id=0002c638&scoped=true&ts=true"
import script from "./OffCanvasBody.vue?vue&type=script&lang=ts"
export * from "./OffCanvasBody.vue?vue&type=script&lang=ts"

import "./OffCanvasBody.vue?vue&type=style&index=0&id=0002c638&lang=scss&scoped=true"

import exportComponent from "/opt/atlassian/pipelines/agent/build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0002c638"]])

export default __exports__